export const actQuotesData = [
  {
    "name": "ACT",
    "value": 1,
    "lat": -35.2812742,
    "lng": 149.1172023
  },
  {
    "name": "Acton",
    "value": 4,
    "lat": -35.2852323,
    "lng": 149.1129681
  },
  {
    "name": "Amaroo",
    "value": 1,
    "lat": -35.169587,
    "lng": 149.1280212
  },
  {
    "name": "Bruce",
    "value": 1,
    "lat": -35.2453517,
    "lng": 149.0916334
  },
  {
    "name": "Campbell",
    "value": 1,
    "lat": -35.28059825,
    "lng": 149.14932371073422
  },
  {
    "name": "Canberra",
    "value": 4,
    "lat": -35.2975906,
    "lng": 149.1012676
  },
  {
    "name": "Canberra Airport",
    "value": 1,
    "lat": -35.304391,
    "lng": 149.1936903
  },
  {
    "name": "Capital Hill",
    "value": 3,
    "lat": -35.3078633,
    "lng": 149.1244839
  },
  {
    "name": "Chapman",
    "value": 1,
    "lat": -35.3562094,
    "lng": 149.0374543
  },
  {
    "name": "Coombs",
    "value": 1,
    "lat": -35.3167344,
    "lng": 149.0425254
  },
  {
    "name": "Deakin",
    "value": 3,
    "lat": -35.318898,
    "lng": 149.0930095748252
  },
  {
    "name": "Denman Prospect",
    "value": 2,
    "lat": -35.29457575,
    "lng": 149.02702410915066
  },
  {
    "name": "Dickson",
    "value": 2,
    "lat": -35.2527861,
    "lng": 149.1417216
  },
  {
    "name": "Forrest",
    "value": 1,
    "lat": -35.3172087,
    "lng": 149.1248559
  },
  {
    "name": "Fyshwick",
    "value": 1,
    "lat": -35.3216575,
    "lng": 149.1708774
  },
  {
    "name": "Googong",
    "value": 1,
    "lat": -35.4883502,
    "lng": 149.0026942
  },
  {
    "name": "Goulburn",
    "value": 3,
    "lat": -35.2512117,
    "lng": 149.0622042
  },
  {
    "name": "Gungahlin",
    "value": 1,
    "lat": -35.1788782,
    "lng": 149.123653
  },
  {
    "name": "HARMAN",
    "value": 1,
    "lat": -35.3484816,
    "lng": 149.1997828
  },
  {
    "name": "Holt",
    "value": 2,
    "lat": -35.2243961,
    "lng": 149.0119295
  },
  {
    "name": "Hume",
    "value": 2,
    "lat": -35.3853817,
    "lng": 149.1658468
  },
  {
    "name": "Lake Burley Griffin",
    "value": 1,
    "lat": -35.29909515,
    "lng": 149.07966585682613
  },
  {
    "name": "Macnamara",
    "value": 1,
    "lat": -35.2186569,
    "lng": 148.9764412
  },
  {
    "name": "Majura",
    "value": 2,
    "lat": -35.2751243,
    "lng": 149.2101716
  },
  {
    "name": "Mitchell",
    "value": 1,
    "lat": -35.2188934,
    "lng": 149.1363833
  },
  {
    "name": "Ngunnawal",
    "value": 1,
    "lat": -35.1727896,
    "lng": 149.1114681
  },
  {
    "name": "Nicholls",
    "value": 4,
    "lat": -35.1871606,
    "lng": 149.0964814
  },
  {
    "name": "Paddy's River",
    "value": 1,
    "lat": -35.4181314,
    "lng": 148.9607987
  },
  {
    "name": "Parkes",
    "value": 2,
    "lat": -35.29652355,
    "lng": 149.12957364767345
  },
  {
    "name": "Phillip",
    "value": 2,
    "lat": -35.3470436,
    "lng": 149.091009
  },
  {
    "name": "Taylor",
    "value": 2,
    "lat": -35.1468038,
    "lng": 149.1071989
  },
  {
    "name": "Watson",
    "value": 6,
    "lat": -35.2348235,
    "lng": 149.1594458
  },
  {
    "name": "Yarralumla",
    "value": 1,
    "lat": -35.3040411,
    "lng": 149.0986347
  }
];
